import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EaPipesModule } from '@app/pipes/ea-pipes.module';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { PrProgressModule } from '../pr-progress/pr-progress.module';
import { PrRiskLevelLadderModule } from '../pr-risk-level-ladder/pr-risk-level-ladder.module';
import { PrValueComponent } from './pr-value.component';

@NgModule({
  declarations: [PrValueComponent],
  imports: [
    CommonModule,
    PrProgressModule,
    PrIconModule,
    EaPipesModule,
    PrRiskLevelLadderModule,
  ],
  exports: [PrValueComponent],
})
export class PrValueModule {}
